import {React,useState, useRef, useEffect} from "react";

export default function Paquetes(){
    const maxScrollWidth = useRef(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const carousel = useRef(null);

    const movePrev = () => {
      if (currentIndex > 0) {
        setCurrentIndex((prevState) => prevState - 1);
      }
    };
  
    const moveNext = () => {
      if (
        carousel.current !== null &&
        carousel.current.offsetWidth * currentIndex <= maxScrollWidth.current
      ) {
        setCurrentIndex((prevState) => prevState + 1);
      }
    };
  
    const isDisabled = (direction) => {
      if (direction === 'prev') {
        return currentIndex <= 0;
      }
  
      if (direction === 'next' && carousel.current !== null) {
        return (
          carousel.current.offsetWidth * currentIndex >= maxScrollWidth.current
        );
      }
  
      return false;
    };
  
    useEffect(() => {
      if (carousel !== null && carousel.current !== null) {
        carousel.current.scrollLeft = carousel.current.offsetWidth * currentIndex;
      }
    }, [currentIndex]);
  
    useEffect(() => {
      maxScrollWidth.current = carousel.current
        ? carousel.current.scrollWidth - carousel.current.offsetWidth
        : 0;
    }, []);
return(
    <div className="container mx-auto my-3 lg:my-5">
      <div className="flex flex-row justify-center my-5">
          <h1 className="font-bold text-green-400 text-3xl">Nuestros Paquetes</h1>
      </div>
      <div className="carousel mx-auto">
        <div className="relative overflow-hidden">
          <div className="flex justify-between absolute top left w-full h-full py-3">
            <button
              onClick={movePrev}
              className="hover:bg-blue-900/75 text-green-400 w-10 h-full text-center opacity-75 hover:opacity-100 disabled:opacity-75 disabled:cursor-not-allowed z-10 p-0 m-0 transition-all ease-in-out duration-300"
              disabled={isDisabled('prev')}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-20 w-30 -ml-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              <span className="sr-only">Anterior</span>
            </button>
            <button
              onClick={moveNext}
              className="hover:bg-blue-900/75 text-green-600 w-10 h-full text-center opacity-75 hover:opacity-100 disabled:opacity-75 disabled:cursor-not-allowed z-10 p-0 m-0 transition-all ease-in-out duration-300"
              disabled={isDisabled('next')}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-20 w-30 -ml-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
                <span className="sr-only">Siguiente</span>
            </button>
          </div>
          <div
          ref={carousel}
          className="carousel-container relative flex gap-10 overflow-hidden scroll-smooth snap-x snap-mandatory touch-pan-x z-0 py-3"
          >
            <div className='carousel-item text-center relative w-96 h-[600px] snap-start'>
              <div className="h-full w-full aspect-square block bg-origin-padding bg-left-top bg-cover bg-no-repeat z-0 bg-white"><img src='/images/P1.jpg' alt='Viaje Redondo Viajes Manguen' className='overflow-auto w-full h-full aspect-square shadow-md rounded-2xl' /></div>
            </div>
            <div className='carousel-item text-center relative w-96 h-[600px] snap-start'>
              <div className="h-full w-full aspect-square block bg-origin-padding bg-left-top bg-cover bg-no-repeat z-0 bg-white"><img src='/images/P2.jpg' alt='Viaje Redondo Viajes Manguen' className='overflow-auto w-full h-full aspect-square shadow-md rounded-2xl' /></div>
            </div>
            <div className='carousel-item text-center relative w-96 h-[600px] snap-start'>
              <div className="h-full w-full aspect-square block bg-origin-padding bg-left-top bg-cover bg-no-repeat z-0 bg-white"><img src='/images/P3.jpg' alt='Viaje Redondo Viajes Manguen' className='overflow-auto w-full h-full aspect-square shadow-md rounded-2xl' /></div>
            </div>
            <div className='carousel-item text-center relative w-96 h-[600px] snap-start'>
              <div className="h-full w-full aspect-square block bg-origin-padding bg-left-top bg-cover bg-no-repeat z-0 bg-white"><img src='/images/P4.jpg' alt='Viaje Redondo Viajes Manguen' className='overflow-auto w-full h-full aspect-square shadow-md rounded-2xl' /></div>
            </div>
            <div className='carousel-item text-center relative w-96 h-[600px] snap-start'>
              <div className="h-full w-full aspect-square block bg-origin-padding bg-left-top bg-cover bg-no-repeat z-0 bg-white"><img src='/images/P5.jpg' alt='Viaje Redondo Viajes Manguen' className='overflow-auto w-full h-full aspect-square shadow-md rounded-2xl' /></div>
            </div>
            <div className='carousel-item text-center relative w-96 h-[600px] snap-start'>
              <div className="h-full w-full aspect-square block bg-origin-padding bg-left-top bg-cover bg-no-repeat z-0 bg-white"><img src='/images/P6.jpg' alt='Viaje Redondo Viajes Manguen' className='overflow-auto w-full h-full aspect-square shadow-md rounded-2xl' /></div>
            </div>
            <div className='carousel-item text-center relative w-96 h-[600px] snap-start'>
              <div className="h-full w-full aspect-square block bg-origin-padding bg-left-top bg-cover bg-no-repeat z-0 bg-white"><img src='/images/P7.jpg' alt='Viaje Redondo Viajes Manguen' className='overflow-auto w-full h-full aspect-square shadow-md rounded-2xl' /></div>
            </div>
            <div className='carousel-item text-center relative w-96 h-[600px] snap-start'>
              <div className="h-full w-full aspect-square block bg-origin-padding bg-left-top bg-cover bg-no-repeat z-0 bg-white"><img src='/images/P8.jpg' alt='Viaje Redondo Viajes Manguen' className='overflow-auto w-full h-full aspect-square shadow-md rounded-2xl' /></div>
            </div>
          </div>
        </div>
      </div>
  </div>
);

}